import { computed, Ref } from 'vue';

const useCheckCharacterCount = (
  comment: Ref<string>,
  maxLength: number
) => {
  const remaining = computed(() => maxLength - comment.value.length);
  const exceededCharacterCount = computed(() => remaining.value < 0);
  const isWarning = computed(() => !exceededCharacterCount.value && remaining.value <= 300);

  const characterLabel = computed(() => (remaining.value !== 1 ? 'characters' : 'character'));
  const warningMessage = computed(() => (isWarning.value ? '. Keep it concise' : ''));
  const message = computed(() => {
    if (remaining.value === 0) {
      return 'Reached character limit';
    } else if (exceededCharacterCount.value) {
      return 'Exceeded character limit';
    } else {
      return `${remaining.value} ${characterLabel.value} remaining${warningMessage.value}`;
    }
  });

  return { remaining, exceededCharacterCount, isWarning, message };
};

export default useCheckCharacterCount;